/**
 * Owner: Masa Bayu
 * File: advanced-flip.ts
 * Date:Time: 2026-09-16 18:50
 * Description: T8-E5 Flip intent — QXRead packages; QXReader executes Flip.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { assertT8E5SecurityIntact } from './advanced-security';
import { createQxreadId } from './id';
import { assertTimestamp, assertValidId } from './guards';
export const QXREAD_FLIP_INTENT_KINDS = ['next', 'previous', 'goto'];
function assertKind(value, label) {
    if (typeof value !== 'string' ||
        !QXREAD_FLIP_INTENT_KINDS.includes(value)) {
        throw new Error(`${label} must be one of: ${QXREAD_FLIP_INTENT_KINDS.join(', ')}`);
    }
    return value;
}
export function createFlipIntent(input) {
    assertNoForbiddenFoundationKey(input, 'QXRead Flip intent');
    assertT8E5SecurityIntact();
    assertValidId(input.publicationId, 'QXRead flip publicationId');
    const kind = assertKind(input.kind, 'QXRead flip kind');
    let targetPage = null;
    if (kind === 'goto') {
        if (typeof input.targetPage !== 'number' ||
            !Number.isInteger(input.targetPage) ||
            input.targetPage < 1) {
            throw new Error('Flip goto requires targetPage >= 1');
        }
        targetPage = input.targetPage;
    }
    const createdAt = input.createdAt ?? new Date().toISOString();
    assertTimestamp(createdAt, 'QXRead flip createdAt');
    const flipIntentId = input.flipIntentId !== undefined ? input.flipIntentId : createQxreadId('qxrdflip');
    assertValidId(flipIntentId, 'QXRead flipIntentId');
    return Object.freeze({
        flipIntentId,
        publicationId: input.publicationId,
        kind,
        targetPage,
        createdAt,
        executesInQxread: false,
        executesInQxReader: true,
        inventsEntitlement: false,
        mutatesQxp: false,
    });
}
//# sourceMappingURL=advanced-flip.js.map